import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Flex,
  Icon,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { useState } from 'react';
import { FiBell } from 'react-icons/fi';

import { NotificationScroll } from './NotificationScroll';

import { useAuth } from '@/lib/authentication';

export const NotificationSidebar = () => {
  const auth = useAuth();
  const [unreadNotifications] = useState([]);
  const { isOpen, onClose, onToggle } = useDisclosure();

  if (!auth?.user) {
    return null;
  }

  return (
    <>
      <Button
        zIndex={99}
        position="absolute"
        right="2.5rem"
        top="1.5rem"
        w="3rem"
        h="3rem"
        rounded="full"
        boxShadow="4px 4px 10px #464646"
        onClick={onToggle}
      >
        <Icon as={FiBell} w="2rem" />
        {unreadNotifications?.length > 0 && (
          <Box
            border="2px solid black"
            fontSize="0.6rem"
            fontWeight="bold"
            w="fit-content"
            rounded="full"
            position="relative"
            top="-3.3rem"
            left="2.5rem"
            minW="1.1rem"
            textAlign="center"
          >
            {unreadNotifications.length}
          </Box>
        )}
      </Button>
      <Drawer size="sm" isOpen={isOpen} onClose={onClose} placement="right">
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />

          <DrawerBody pt="4rem">
            <Flex alignItems="center" flexDirection="column">
              <Flex w="100%" justifyContent="center" height="fit-content">
                <Box rounded="full" boxShadow="4px 4px 10px #c4c4c4">
                  <Icon w="50px" h="50px" p="12px" as={FiBell} size="1.5rem" />
                </Box>
                {unreadNotifications?.length > 0 && (
                  <Box
                    border="2px solid black"
                    fontSize="0.6rem"
                    fontWeight="bold"
                    w="fit-content"
                    rounded="full"
                    position="relative"
                    top="-3.3rem"
                    left="2.5rem"
                    minW="1.1rem"
                    textAlign="center"
                  >
                    {unreadNotifications.length}
                  </Box>
                )}
              </Flex>
              <Text
                fontSize="1.375rem"
                letterSpacing="0.055rem"
                textAlign="center"
                fontWeight={600}
                mt="1.75rem"
                mb="2rem"
              >
                Últimas notificações
              </Text>
            </Flex>
            <NotificationScroll onClose={onClose} />
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
};
